import { defineAction, enumerated, object, string } from '~/prix'
import fetchOpenStreetMapStateIdAction from './fetchOpenStreetMapStateId.action.json'

const fetchOpenStreetMapIdDefinition = defineAction({
  ...fetchOpenStreetMapStateIdAction,
  input: object({
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
  }),
  output: object({}),
})

export default fetchOpenStreetMapIdDefinition
